export const MESHY_AI_MODELS = [ 'meshy-5', 'meshy-6', 'latest' ];
export const MESHY_MODEL_TYPES = [ 'standard', 'smart-topology', 'lowpoly' ];
export const MESHY_TOPOLOGIES = [ 'triangle', 'quad' ];
export const MESHY_POSE_MODES = [ '', 'a-pose', 't-pose' ];
export const MESHY_POLYCOUNT_MIN = 100;
export const MESHY_POLYCOUNT_MAX = 300000;
export const MESHY_POLYCOUNT_MAX_SMART = 15000;
export const MESHY_TEXTURE_PROMPT_MAX = 600;

export const MESHY_DEFAULTS = {
  aiModel: 'latest',
  modelType: 'standard',
  topology: 'triangle',
  targetPolycount: 30000,
  shouldRemesh: true,
  shouldTexture: true,
  enablePBR: false,
  hdTexture: false,
  imageEnhancement: true,
  removeLighting: true,
  texturePrompt: '',
  poseMode: '',
  moderation: false,
};

const isMeshy6OrLatest = aiModel => aiModel === 'meshy-6' || aiModel === 'latest';

export const meshyPolycountMax = modelType =>
  (modelType === 'smart-topology' ? MESHY_POLYCOUNT_MAX_SMART : MESHY_POLYCOUNT_MAX);

export const buildMeshyProperties = settings => {
  const {
    aiModel,
    modelType,
    topology,
    targetPolycount,
    shouldRemesh,
    shouldTexture,
    enablePBR,
    hdTexture,
    imageEnhancement,
    removeLighting,
    texturePrompt,
    poseMode,
    moderation,
  } = settings;

  const properties = {
    aiModel,
    modelType,
    topology,
    targetPolycount: Number(targetPolycount),
    shouldRemesh,
    shouldTexture,
  };

  if (shouldTexture) {
    properties.enablePBR = enablePBR;
    if (isMeshy6OrLatest(aiModel)) {
      properties.hdTexture = hdTexture;
    }
    if (texturePrompt) {
      properties.texturePrompt = texturePrompt;
    }
  }

  if (isMeshy6OrLatest(aiModel)) {
    properties.imageEnhancement = imageEnhancement;
    properties.removeLighting = removeLighting;
  }

  if (poseMode) {
    properties.poseMode = poseMode;
  }
  if (moderation) {
    properties.moderation = moderation;
  }

  return properties;
};

export const validateMeshySettings = settings => {
  const errors = {};
  const { aiModel, modelType, topology, targetPolycount, poseMode, texturePrompt } = settings;

  if (!MESHY_AI_MODELS.includes(aiModel)) {
    errors.aiModel = 'Invalid AI model.';
  }
  if (!MESHY_MODEL_TYPES.includes(modelType)) {
    errors.modelType = 'Invalid model type.';
  }
  if (!MESHY_TOPOLOGIES.includes(topology)) {
    errors.topology = 'Invalid topology.';
  }

  const numericPolycount = Number(targetPolycount);
  const max = meshyPolycountMax(modelType);
  if (!Number.isFinite(numericPolycount)
    || numericPolycount < MESHY_POLYCOUNT_MIN
    || numericPolycount > max) {
    errors.targetPolycount = `Target polycount must be between ${MESHY_POLYCOUNT_MIN} and ${max}.`;
  }

  if (!MESHY_POSE_MODES.includes(poseMode)) {
    errors.poseMode = 'Invalid pose mode.';
  }

  if (texturePrompt && texturePrompt.length > MESHY_TEXTURE_PROMPT_MAX) {
    errors.texturePrompt = `Texture prompt must be ${MESHY_TEXTURE_PROMPT_MAX} characters or fewer.`;
  }

  return { valid: Object.keys(errors).length === 0, errors };
};
